module.exports = __webpack_public_path__ + "static/spotify-quiz.60ac3062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/spotify-quiz.png
// module id = 479
// module chunks = 35783957827783